import { render, staticRenderFns } from "./DeleteModuleDialog.vue?vue&type=template&id=8e4689e6&scoped=true"
import script from "./DeleteModuleDialog.vue?vue&type=script&lang=js"
export * from "./DeleteModuleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4689e6",
  null
  
)

export default component.exports